import { render } from "./TUIEditor.vue?vue&type=template&id=2f574f94&scoped=true&ts=true"
import script from "./TUIEditor.vue?vue&type=script&lang=ts"
export * from "./TUIEditor.vue?vue&type=script&lang=ts"

import "./TUIEditor.vue?vue&type=style&index=0&id=2f574f94&scoped=true&lang=css"
import "./TUIEditor.vue?vue&type=style&index=1&id=2f574f94&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f574f94"]])

export default __exports__